import React__default, { useMemo, useState, useEffect, cloneElement } from 'react';
import PropTypes from 'prop-types';
import Modal from './Modal.js';
import { I as Icon } from './index-11bc5ac3.js';
import { n as nodeOrStringProp } from './PropTypes-e1e509ba.js';
import { a as _slicedToArray, j as _asyncToGenerator, k as _regeneratorRuntime } from './_rollupPluginBabelHelpers-e71b1aad.js';
import Title from './Title.js';
import 'react-dom';
import './ModalHeader-77a50105.js';
import './tslib.es6-2748fcb6.js';
import './_commonjsHelpers-17042db9.js';
import 'moment';

function MapModal(_ref) {
  var width = _ref.mapWidth,
    height = _ref.mapHeight,
    _ref$location = _ref.location,
    latitude = _ref$location.latitude,
    longitude = _ref$location.longitude,
    zoom = _ref.zoomLevel,
    triggerText = _ref.triggerText,
    modalTitle = _ref.modalTitle,
    modalFooter = _ref.modalFooter,
    modalSize = _ref.modalSize,
    closeIcon = _ref.closeIcon,
    onClose = _ref.onClose,
    onOpen = _ref.onOpen,
    className = _ref.className,
    isQA = _ref.isQA,
    MapInstance = _ref.mapProvider;
  var trigger = useMemo(function () {
    return /*#__PURE__*/React__default.createElement("span", {
      className: "bf-map-modal-trigger ".concat(className)
    }, /*#__PURE__*/React__default.createElement(Icon, {
      name: "bf-icon-map-marker"
    }), /*#__PURE__*/React__default.createElement("span", {
      className: "bf-map-modal-trigger-text bf-text-link",
      "data-test-id": isQA ? 'bf-map-modal-trigger-text' : null
    }, triggerText))
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ;
  }, [isQA, className]);
  return !!(latitude && longitude) && /*#__PURE__*/React__default.createElement(Modal, {
    content: /*#__PURE__*/React__default.createElement(MapInstance, {
      width: width,
      height: height,
      center: {
        latitude: latitude,
        longitude: longitude
      },
      markers: [{
        latitude: latitude,
        longitude: longitude
      }],
      zoom: zoom
    }),
    trigger: trigger,
    title: modalTitle,
    footer: modalFooter,
    size: modalSize,
    closeIcon: closeIcon,
    onClose: onClose,
    onOpen: onOpen,
    className: "bf-map-modal"
  });
}
MapModal.defaultProps = {
  mapWidth: '100%',
  mapHeight: '400px',
  zoomLevel: 14,
  triggerText: '',
  modalTitle: '',
  modalFooter: '',
  modalSize: '',
  closeIcon: true,
  onClose: function onClose() {},
  onOpen: function onOpen() {},
  className: '',
  isQA: false
};
MapModal.propTypes = {
  mapWidth: PropTypes.string,
  mapHeight: PropTypes.string,
  location: PropTypes.shape({
    latitude: PropTypes.number,
    longitude: PropTypes.number,
    address: PropTypes.string,
    city: PropTypes.string,
    country: PropTypes.string
  }).isRequired,
  zoomLevel: PropTypes.number,
  triggerText: nodeOrStringProp,
  modalTitle: nodeOrStringProp,
  modalFooter: nodeOrStringProp,
  modalSize: PropTypes.string,
  closeIcon: PropTypes.bool,
  onClose: PropTypes.func,
  onOpen: PropTypes.func,
  className: PropTypes.string,
  isQA: PropTypes.bool,
  mapProvider: PropTypes.elementType.isRequired
};

function Map(_ref) {
  var showDemoProperties = _ref.showDemoProperties,
    getMarkers = _ref.getMarkers,
    trackEvent = _ref.trackEvent,
    locations = _ref.locations,
    children = _ref.children,
    MapInstance = _ref.mapProvider,
    labels = _ref.labels,
    i18n = _ref.i18n,
    _ref$channelSettings = _ref.channelSettings,
    channelId = _ref$channelSettings.id,
    landingPageMap = _ref$channelSettings.landingPageMap,
    country = _ref$channelSettings.country;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    currentMarkers = _useState2[0],
    setCurrentMarkers = _useState2[1];
  useEffect(function () {
    function initMarkers() {
      return _initMarkers.apply(this, arguments);
    }
    function _initMarkers() {
      _initMarkers = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _response$data;
        var response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getMarkers({
                channelId: channelId,
                showDemoProperties: showDemoProperties
              });
            case 2:
              response = _context.sent;
              setCurrentMarkers(response.data);
              trackEvent('mapIsDisplayed', {
                channelId: channelId,
                amountOfHotels: response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.locations.length
              });
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _initMarkers.apply(this, arguments);
    }
    if (locations) {
      setCurrentMarkers({
        locations: locations
      });
    } else {
      initMarkers();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [channelId]);
  return !!currentMarkers && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, landingPageMap.title || landingPageMap.teaser ? /*#__PURE__*/React__default.createElement("div", {
    className: "map-page-intro"
  }, landingPageMap.title ? /*#__PURE__*/React__default.createElement(Title, {
    content: landingPageMap.title,
    size: "medium",
    className: "map-page-intro-title"
  }) : null, landingPageMap.teaser ? /*#__PURE__*/React__default.createElement("div", {
    className: "map-page-intro-teaser"
  }, landingPageMap.teaser) : null) : null, /*#__PURE__*/React__default.createElement(MapInstance, {
    markers: currentMarkers.locations,
    popupLoadingText: labels.loading,
    fromChina: country === 'CN',
    i18n: i18n
  }, children ? cloneElement(children, {
    labels: labels
  }) : null));
}
Map.defaultProps = {
  showDemoProperties: false,
  locations: null,
  children: null,
  i18n: null
};
Map.propTypes = {
  labels: PropTypes.shape().isRequired,
  locations: PropTypes.arrayOf(PropTypes.shape({})),
  children: PropTypes.node,
  channelSettings: PropTypes.shape({
    id: PropTypes.string,
    isProduction: PropTypes.bool,
    landingPageMap: PropTypes.shape({
      title: PropTypes.string,
      teaser: PropTypes.string
    }),
    country: PropTypes.string
  }).isRequired,
  i18n: PropTypes.shape({
    messages: PropTypes.shape({}),
    locale: PropTypes.string,
    IntlProvider: PropTypes.func
  }),
  showDemoProperties: PropTypes.bool,
  getMarkers: PropTypes.func.isRequired,
  trackEvent: PropTypes.func.isRequired,
  mapProvider: PropTypes.elementType.isRequired
};

/* eslint-disable import/no-cycle */

/**
 * From here are exported all the kind of map that we have in the system for use.
 * At the moment just two kind of map renders are possible, one with all the features
 * in it, and another one super simple that shows only one location in a Modal.
 */

var MapView = {};
MapView.Modal = MapModal;
MapView.Modal.displayName = 'MapModal';
MapView.Full = Map;
MapView.Full.displayName = 'MapFull';

export default MapView;
//# sourceMappingURL=MapView.js.map
